import * as React from 'react';
import './styles.scss';
import { forwardRef } from 'react';
import { ErrorMessage } from 'react-hook-form';

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: JSX.Element;
  errors?: any;
  showReadOnly?: boolean;
}

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ id, label, errors, showReadOnly, ...inputProps }, ref) => {
    const hasError: boolean = errors && errors[id];

    if (showReadOnly) {
      return (<div className="form-input__read-only">
        <label htmlFor={id}>{label}</label>
        <div className="form-input__read-only-value" id={id}>{inputProps.defaultValue || "Not answered"}</div>
      </div>)
    }

    return (
      <>
        <label htmlFor={id}>{label}</label>
        <input {...inputProps} id={id} name={id} type={inputProps.type || "text"} className={`input--text ${hasError ? "input--error" : ""}`} ref={ref} />
        {hasError && <div className="form-input__error"><ErrorMessage errors={errors} name={id} /></div>}
      </>
    )
  }
);